import React from 'react';

const RedirectIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2223 3H13.0002M13.0002 3V5.77785M13.0002 3L9.11078 6.88899M11.8891 9.11078V11.8886C11.8891 12.5025 11.3919 12.9998 10.778 12.9998H4.11114C3.49724 12.9998 3 12.5025 3 11.8886V5.22179C3 4.60788 3.49724 4.11065 4.11114 4.11065H6.88899"
        stroke="#848484"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RedirectIcon;
